/**
 * Error Interceptor
 *
 * Why: Centralize error handling for all API requests
 * What: Handles common errors (401,403,500,network errors)
 * Benefits: Constant error handling. automatic token refresh,user notifications
 */

import type { AxiosError, InternalAxiosRequestConfig } from "axios";
import { logger } from "../../../utils";
import { apiConfig } from "../../../../config";

/**
 * Track if we're currently refreshing the token
 * Why: Prevent multiple simultaneous refresh requests
 */

let isRefreshing: boolean = false;

/**
 * Queue of failed requests waiting for token refresh
 * Why: Retry failed requests after token is refreshed
 */

let failedQueue: Array<{
  resolve: (value?: unknown) => void;
  reject: (reason?: unknown) => void;
}> = [];

/**
 * Process the queue of failed requests
 */

const processQueue = (error: Error | null, token: string | null = null) => {
  failedQueue.forEach((promise) => {
    if (error) promise.reject(error);
    else promise.resolve(token);
  });
  failedQueue = [];
};

/**
 * Handle response errors
 */
export const errorResponseInterceptor = async (
  error: AxiosError,
): Promise<unknown> => {
  const originalRequest = error.config as InternalAxiosRequestConfig & {
    _retry?: boolean;
  };

  // skip error handling if requested
  if (
    (originalRequest as unknown as Record<string, unknown>).skipErrorHandler
  ) {
    return Promise.reject(error);
  }

  // =======================
  // 🔹 Handle 401 Unauthorized
  // =======================

  if (error.response?.status === 401 && !originalRequest._retry) {
    logger.warn("401 Unauthorized - Attempting token refresh");

    // If already refreshing. queue this request
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers.Authorization = `${apiConfig.token.prefix} ${token}`;
          return Promise.resolve(originalRequest);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }
    // Mark as retrying to prevent infinite loop
    originalRequest._retry = true;
    isRefreshing = true;

    // Get refresh token
    // const refreshToken = storage.get<string>(apiConfig.token.refreshStorageKey);
    const refreshToken = "abc";
    if (!refreshToken) {
      // No refresh token redirect to login
      logger.error("No refresh token available");
      processQueue(new Error("No refresh token"), null);

      // Clear storage and redirect to login
      window.location.href = "/login";
      return Promise.reject(error);
    }
    window.location.href = "/login";
    // try {

    // } catch (error) {

    // }
  }
};
